import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Center from 'components/Center';
import { Link } from 'react-router-dom';
import { home } from 'pages/routes';

export default function NotFoundPage () {
  return (
    <Center force>
      <Box textAlign="center">
        <Typography variant="h1">404</Typography>
        <Typography variant="h6">página não encontrada</Typography>
        <Box mt={2}>
          <Typography component={Link} to={home}>
            voltar para o início
          </Typography>
        </Box>
      </Box>
    </Center>
  );
}
